module.exports = __webpack_public_path__ + "static/media/results.0ce50b38.png";